<template>
  <DxPopup
    :visible.sync="showPopup"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-title="showTitle"
    :title="popupTitle"
    :width="popupWidth"
    :height="popupHeight"
    :showCloseButton="false"
    @hidden="popupHidden"
    :fullScreen="fullScreen"
    @content-ready="setFullScreen"
    ref="gc-popup"
    :titleTemplate="popupTitle ? undefined : 'titleTemplate'"
    :wrapperAttr="wrapperAttr"
  >
    <template #titleTemplate>
      <div class="custom-title" v-if="!popupTitle">
        <span class="title-primary">{{ popupTitles.primary }}</span>
        <span class="title-secondary"> {{ popupTitles.secondary }}</span>
      </div>
      <div class="custom-title" v-else>
        <span class="title-primary">{{ popupTitle }}</span>
      </div>
    </template>
    <slot></slot>

    <div
      class="footer"
      v-bind:class="
        saveButtonConfig
          ? popUpContent == 'gc-data-grid'
            ? 'multi-btn gc-data-grid'
            : 'multi-btn'
          : null
      "
    >
      <DxButton
        v-if="saveButtonConfig"
        :text="saveButtonConfig.text"
        type="success"
        styling-mode="contained"
        @click="onUpdate"
        :disabled="saveButtonConfig.disabled"
      />
      <DxButton
        :text="backButtonConfig ? backButtonConfig.text : 'back'"
        type="default"
        styling-mode="contained"
        @click="onClickBackButton"
      />
    </div>
  </DxPopup>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
export default {
  mixins: [RouteMixin, FormMixin],
  props: {
    popupVisible: {
      type: Boolean,
      default: false,
    },
    backButtonFunction: {
      type: Function,
      default: () => {},
    },
    popUpScreenOptions: {
      type: Array,
      default: undefined,
    },
    popupTitle: {
      type: String,
      default: undefined,
    },
    popupTitles: {
      type: Object,
      default: () => {},
    },
    popupHeight: {
      type: [Number, String],
      default: 600,
    },
    popupWidth: {
      type: [Number, String],
      default: 550,
    },
    hidden: {
      type: Function,
      default: () => {},
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    saveButtonConfig: {
      type: [Object, Boolean],
      default: false,
    },
    backButtonConfig: {
      type: [Object, Boolean],
      default: false,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    popUpContent: {
      type: String,
      default: "gc-form",
    },
    titleTemplate: {
      type: String,
      default: null,
    },
    saveValidation: {
      type: [Function, Array],
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    onClickBackButton() {
      if (this.backButtonConfig) this.backButtonConfig.clickCallback();
      else this.backButtonFunction();
    },
    onUpdate() {
      if (!this.saveValidation) {
        // console.log(">>> 1");
        if (this.dataModel) this.saveButtonConfig.clickCallback(this.dataModel);
        else this.saveButtonConfig.clickCallback();
      } else {
        // console.log(">>> 2");
        this.saveValidation();
      }
    },
    popupHidden() {
      if (this.hidden) this.hidden();
      if (!this.fullScreen) this.backButtonFunction();
      if (this.backButtonConfig) this.backButtonConfig.clickCallback();
    },
    setFullScreen(e) {
      if (this.fullScreen) {
        // eslint-disable-next-line no-console
        console.log("onShown", e.component.content());
        e.component.content().classList.add("gc-full-screen-popup");
      }
    },
  },
  computed: {
    showPopup: {
      get() {
        return this.popupVisible;
      },
      set() {
        return false;
      },
    },
  },
  watch: {
    // saveButtonConfig: {
    //   handler(val) {
    //     console.log("AAAA ", val);
    //   },
    //   deep: true,
    // },
  },
};
</script>

<style lang="scss">
.custom-title {
  padding-top: 25px;
  padding-bottom: 25px;
}

.title-primary {
  font-size: 20px;
  font-weight: 500;
}

.title-secondary {
  padding-left: 8px;
  font-size: 16px;
  color: #957f7f;
}

.gc-full-screen-popup {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.footer.multi-btn {
  display: flex;
  flex-direction: row;

  .dx-button {
    display: flex;
    justify-content: center;
    flex-grow: 1;
    margin-right: 5px;
  }

  .dx-button:last-child {
    margin-right: 0px;
  }
}

.footer.gc-data-grid {
  justify-content: flex-end !important;
  .dx-button {
    flex-grow: unset !important;
  }
}

.dx-popup-fullscreen {
  .dx-toolbar {
    background-color: #03a9f4;
    .dx-item-content.dx-toolbar-item-content {
      color: white !important;
    }
  }
}
</style>
<style scoped>
.footer {
  padding-top: 10px;
  bottom: 0;
  height: 45px;
  text-align: right;
}
.footer .save-btn {
  margin-right: 10px;
}
</style>
